(function($,Drupal) {

  Drupal.behaviors.tabbedBlock = {
    attach(context) {
      const $tabNavLinks = $('.tab_nav--link');
      const $tabContents = $('.tab--content');
      $tabNavLinks.on('click', function() {
          const $this = $(this);
          const tabIndex = $this.data('tab');
          const tabName = $this.text().trim();

          $tabNavLinks.removeClass('active').css({ outline: '', color: ''})
          $this.addClass('active');

          $tabContents.addClass('hidden');
          $(`.tab--content[data-tab='${tabIndex}']`).removeClass('hidden');

          const event = new CustomEvent('tab-activated', {detail: {tabName} });
          document.dispatchEvent(event);
      });
    },
  };

})(jQuery, Drupal);
